import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { restaurarSessaoDoPlanoAtual } from '@/shared/lib/sessoes';
import './styles.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado.');

/**
 * A sessão é restaurada **antes** da primeira renderização.
 *
 * A guarda de rota lê o store de forma síncrona; começar a renderizar antes de
 * a resposta do refresh chegar mandaria todo mundo para a tela de entrada, e o
 * usuário veria o login piscar a cada F5.
 *
 * Roda uma vez no módulo, não num efeito: em StrictMode o efeito de montagem
 * executa duas vezes, e duas rotações do mesmo refresh token são lidas pelo
 * backend como reuso — a sessão seria encerrada por segurança
 * (regra `advanced-init-once`).
 *
 * Encadeado com `.then` em vez de `await` de topo de módulo: `await` no nível
 * do módulo exige alvo ES2022 no bundle, e subir o alvo só por causa desta
 * linha excluiria navegadores que o resto do código atende.
 */
void restaurarSessaoDoPlanoAtual(window.location.pathname).then(() => {
  createRoot(raiz).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
